import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user_id:localStorage.user_id,
    access_token:localStorage.access_token,
    ip:null
  },
  mutations: {
    setuserid(state, data) {
			state.user_id = data //vuex
			localStorage.user_id = data //本地
    },
    settoken(state,data){
			state.access_token = data //vuex
			localStorage.access_token = data //vuex
		}
  },
  actions: {}
});
